export default "__VITE_ASSET__0235aa98__"